module.exports = __webpack_public_path__ + "static/media/chileimage1.f5cc1fad.png";